import { Button, Input, message } from 'antd';
import IntlMessages from "util/IntlMessages";
import React, {useState} from 'react';
import { sendPassowrdChangeLink } from '../services/users-service'


const ForgotPassword = () => {
  const [email, setEmail] = useState('')

  const handleSendEmailLink = async() => {
    const response = await sendPassowrdChangeLink(email)

    if(response.success){
      message.success('Reset password link send to above email')
    } else{
      message.error('Opps! Something went wrong')
    }
  }

  const handleChange = (evt) => {
    setEmail(evt.target.value)
  }
  return (
    <div className="gx-app-login-wrap">
      <div className="gx-app-logo">
        <img alt="example" src={require("assets/images/clarity-logo.png")} />
      </div>
      <div className="gx-app-login-container">
        <div className="gx-app-login-main-content">
            <div className="gx-app-login-content">
                <h1><IntlMessages id="app.userAuth.forgotPassword" /></h1>
                <p><IntlMessages id="app.userAuth.forgot" /></p>
                <Input placeholder='Enter email' type='email' onChange={handleChange}></Input>

                <div style={{marginTop:'20px'}}>
                  <Button type='primary' onClick={handleSendEmailLink}>Send</Button>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword